import Select from 'react-select'

const SingleValue = ({
  selectProps,
  data,
  getStyles,
  ...props
}) => {
  return (
    <div style={getStyles('singleValue', props)}>
      Order By: {selectProps.getOptionLabel(data)}
    </div>
  )
}

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '12px'
  }),
  indicatorSeparator: () => {}
}

export const SortBox = ({ options, sort, setSort, ...rest }) => (
  <Select styles={customStyles} components={{ SingleValue }} options={options} value={sort} onChange={sort => setSort(sort)} {...rest} />
)

export default SortBox
